// @ts-nocheck
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
import AlertTriangleFill from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import { ProductLinePresentationProps } from "@store/Library/Components/ProductLine/ProductLine";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";

const boxPaddingValues = pxToRemArray([16, 20, null, 24]);
const boxRadius = pxToRem(8);

export interface OrderV2Props {
    boxWrapper?: InjectableCss;
    boxesGridContainer?: GridContainerProps;
    boxesWrapper?: InjectableCss;
    boxTopWrapper?: InjectableCss;
    boxBottomWrapper?: InjectableCss;
    sectionTitle?: TypographyPresentationProps;
    sectionWrapper?: InjectableCss;
    changeTooltip?: TooltipPresentationProps;
    infoLabel?: TypographyPresentationProps;
    infoValue?: TypographyPresentationProps;
    infoOldValue?: TypographyPresentationProps;
    infoWrapper?: InjectableCss;
    addressGridItem?: GridItemProps;
    productLine?: ProductLinePresentationProps;
}

const boxWrapperStyles = () => {
    return css`
        ${breakpointValues(boxPaddingValues, "padding")}
        border: 1px solid ${getColor("common.borderLight")};
        border-radius: ${boxRadius};
    `;
};

export const orderV2Props: OrderV2Props = {
    boxWrapper: {
        css: css`
            ${boxWrapperStyles()}
        `,
    },
    boxesGridContainer: { gap: 24 },
    boxesWrapper: {
        css: css`
            width: 100%;
        `,
    },
    boxTopWrapper: {
        css: css`
            ${boxWrapperStyles()}

            &:not(:last-child) {
                border-bottom-right-radius: 0;
                border-bottom-left-radius: 0;
            }
        `,
    },
    boxBottomWrapper: {
        css: css`
            ${boxWrapperStyles()}
            border-top: none;
            background-color: ${getColor("common.accent")};

            &:not(:first-child) {
                border-top-right-radius: 0;
                border-top-left-radius: 0;
            }
        `,
    },
    sectionWrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(40))}
        `,
    },
    sectionTitle: {
        forwardAs: "h2",
        css: css`
            ${spacingStyles(null, pxToRem(24))}
            font-size: ${pxToRem(24)};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    changeTooltip: {
        iconProps: {
            color: "warning",
            src: AlertTriangleFill,
        },
    },
    infoWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(8)};
        `,
    },
    infoLabel: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    infoValue: {},
    infoOldValue: {
        css: css`
            color: ${getColor("text.light")};
            text-decoration: line-through;
        `,
    },
    addressGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
            gap: ${pxToRem(4)};
        `,
    },
    productLine: { gap: pxToRem(24) },
};
